export type NbsDateRangeFilterProps = {
  readonly dateFrom: string;
  readonly dateTo: string;
  readonly onChange: (patch: { dateFrom?: string; dateTo?: string }) => void;
  readonly visible?: boolean;
};

/**
 * Day-level picker — only render when measure granularity is daily/monthly.
 * Year ranges are handled by `NbsYearRangeFilter`.
 */
export function NbsDateRangeFilter({
  dateFrom,
  dateTo,
  onChange,
  visible = false,
}: NbsDateRangeFilterProps) {
  if (!visible) return null;
  return (
    <>
      <label>
        Date début
        <input
          type="date"
          value={dateFrom}
          onChange={(e) => onChange({ dateFrom: e.target.value })}
        />
      </label>
      <label>
        Date fin
        <input type="date" value={dateTo} onChange={(e) => onChange({ dateTo: e.target.value })} />
      </label>
    </>
  );
}
